import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { OrganizationList } from "@/features/organizations/components/organization-list";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@fleet/ui/page-container";

function OrganizationsPage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Organizations`)}
      description={t(
        msg`Create and manage organizations to collaborate with other teams in real time.`,
      )}
    >
      <PageContainer maxWidth="3xl">
        <OrganizationList />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const organizationsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/organizations",
  component: OrganizationsPage,
});
